module.exports = __webpack_public_path__ + "media/images/dev_tools_lg-70c59833e0b24ed0674d72e92506afd8.png";